// extracted by mini-css-extract-plugin
export default {"select":"Select-module__select--jEvwE","portal":"Select-module__portal--o09e1","animatedBackground":"Select-module__animatedBackground--nvqOx"};